(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxSelectVendor(
    NetworkListService, $timeout, TenantListService
  ) {
    return {
      restrict: 'EA',
      scope: {
        vendors: '=vendors',
        callback: '&callback'
      },
      templateUrl: 'app/components/onDeviceConfigProperties/selectVendor/selectVendor.template.html',
      link: function(scope) {

        scope.selectVendor = function (event, vendor) {
          event.stopPropagation();
          scope.callback({vendor: vendor})
        }

        scope.closePopup = function (event) {
          scope.callback();
        }

        
      }
    };
  }

  pxSelectVendor.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxSelectVendor', pxSelectVendor);

})();
